import React from 'react';

export default props => (
  <div className="col-xs-12 clearfix" style={{borderBottom:'1px solid #dddddd', margin: '0px 0 20px 0'}}></div>
);
